import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "me-5"
}

import { withDefaults, ref, watch, onMounted } from 'vue';
import { ITab } from '@/types';
import * as comps from '@/components/atoms';
interface IProps {
  modelValue: string;
  tabs: ITab[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeTabsDate',
  props: {
    modelValue: { default: '' },
    tabs: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;
const tab = ref(props.tabs[0].value)

function updateTab() {
  emit('update:modelValue', tab.value)
}

watch(
  () => tab.value,
  () => {
    updateTab()
  }
)
watch(
  () => props.modelValue,
  () => {
    tab.value = props.modelValue;
  }
)
onMounted(() => {
  if (props.modelValue) tab.value = props.modelValue
})

return (_ctx: any,_cache: any) => {
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!

  return (_openBlock(), _createBlock(_component_v_tabs, {
    modelValue: tab.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tab).value = $event)),
    color: "#17CF97",
    class: "w-100"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.tabs, (itemTab) => {
        return (_openBlock(), _createBlock(_component_v_tab, {
          value: itemTab.value,
          key: itemTab.value,
          class: "text-sm"
        }, {
          default: _withCtx(() => [
            (itemTab.icon)
              ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(comps[itemTab.icon]), {
                    color: (tab.value == itemTab.value ? `#09926C` : '')
                  }, null, 8, ["color"]))
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(itemTab.label), 1)
          ]),
          _: 2
        }, 1032, ["value"]))
      }), 128))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})